import React from 'react';
import _ from "lodash";
import { connect } from 'react-redux';
import { decrementStep, setFormData, verifyAddress } from '../redux/actions';
import AddressVerificationModal from "../../shared/address-verification-modal";
import Complaint from "../../shared/Complaint/index.jsx";
import Comps from '@owenscorning/react-library';
import RadioButton from '../../shared/RadioButton/index.jsx'
import styled from '@emotion/styled';
import TextInput from "../../shared/TextInput/index.jsx";
import { BackArrow } from "../../shared/svgIcons.jsx";

const AddressGroup = Comps.Connect.FormElements.AddressGroup

const StepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 35rem;
  width: 100%;
`;

const RadioContainer = styled.div`
  border: 1px solid #6D6D6D;
  margin-bottom: 1rem;
  max-width: 35rem;
  min-width: 48%;
  padding: 1rem;
`;

const HalfRadioContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Header = styled.h3`
  font-family: 'OCRoboto';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  padding-top: 1rem;
`;

const NextButton = styled.button`
  background-color: #D40F7D;
  border: none;
  color: #FFFFFF;
  cursor: pointer;
  font-size: 18px;
  padding: .5rem;
  width: 100%;

  :disabled {
    background-color: #D8D8D8;
    cursor: default;
  }
`;

const BackWrapper = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;
`;

const BlurredText = styled.p`
  filter: blur(2px);
  margin-top: 0;
  padding-bottom: 1.5rem;
`;

const SplitInputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 1rem;

  > div {
    width: 48%;
  }
`;

const InputWrapper = styled.div`
  width: 100%;
  padding: 0.5em 0;
`;

const mapStateToProps = state => (
  {
    formData: state.formData,
    ownerAddressSameAsProperty: state.formData.ownerAddressSameAsProperty,
    firstName: state.formData.firstName,
    lastName: state.formData.lastName,
    email: state.formData.email,
    phoneNumber: state.formData.phoneNumber
  }
);

const Step3 = ( { verifyAddress, decrementStep, setFormData, formData, ownerAddressSameAsProperty, firstName, lastName, email, phoneNumber } ) => {
  const emailRegEx = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  const validated = (ownerAddressSameAsProperty && firstName && lastName && (emailRegEx.test(email) === true) && formData.userPreferredContact && phoneNumber && !(_.isEmpty(formData.ownerAddress)))

  return (
    <StepWrapper>
      <BackWrapper
        data-track="form-back"
        data-track-form-name="Warranty Transfer"
        data-track-form-step="step 3 - method of contact"
        onClick={decrementStep}
      >
        <BackArrow width="21" height="12" />
        <p>Back</p>
        <BlurredText>When did you close on this property?</BlurredText>
      </BackWrapper>
      <p>Ok, great! Now we’re going to collect some information on you, the new property owner.</p>
      <Header>Contact information:</Header>
      <SplitInputContainer>
        <TextInput
          fieldKey={'firstName'}
          value={formData.firstName || ''}
          htmlAttributes={{
            placeholder: 'First Name',
          }}
        />
        <TextInput
          fieldKey={'lastName'}
          value={formData.lastName || ''}
          htmlAttributes={{
            placeholder: 'Last Name',
          }}
        />
      </SplitInputContainer>
      <InputWrapper>
        <TextInput
          value={formData.email || ''}
          fieldKey={'email'}
          htmlAttributes={{
            placeholder: 'johndoe@gmail.com',
          }}
        />
        <Complaint
          text="Please enter a valid email address."
          show={(!email || emailRegEx.test(email) === false)}
        />
      </InputWrapper>
      <InputWrapper>
        <TextInput
          fieldKey={'phoneNumber'}
          value={formData.phoneNumber || ''}
          htmlAttributes={{
            placeholder: 'Phone Number',
            pattern: "[0-9 -]*",
            isphoneinput: 'true',
            maxLength: 12
          }}
        />
      </InputWrapper>
      <Header>Preferred method of contact:</Header>
      <RadioContainer>
        <RadioButton
          value={"email"}
          fieldKey={'userPreferredContact'}
          htmlAttributes={{}}
        >
          <label>Email</label>
        </RadioButton>
      </RadioContainer>
      <RadioContainer>
        <RadioButton
          value={"phone"}
          fieldKey={'userPreferredContact'}
          htmlAttributes={{}}
        >
          <label>Phone</label>
        </RadioButton>
      </RadioContainer>
      <Header>Is your mailing address the same as this property address?</Header>
      <SplitInputContainer>
        <RadioContainer>
          <RadioButton
            value={"true"}
            fieldKey={'ownerAddressSameAsProperty'}
            htmlAttributes={{}}
          >
            <label>Yes</label>
          </RadioButton>
        </RadioContainer>
        <RadioContainer>
          <RadioButton
            value={"false"}
            fieldKey={'ownerAddressSameAsProperty'}
            htmlAttributes={{}}
          >
            <label>No</label>
          </RadioButton>
        </RadioContainer>
      </SplitInputContainer>
      {(formData.ownerAddressSameAsProperty === "false") &&
        <>
        <Header>What is your mailing address?</Header>
        <HalfRadioContainer>
          <RadioContainer>
              <RadioButton
                value={'US'}
                fieldKey={'ownerCountrySelected'}
                htmlAttributes={{}}
              >
                <label>United States</label>
              </RadioButton>
            </RadioContainer>
            <RadioContainer>
              <RadioButton
                value={'CA'}
                fieldKey={'ownerCountrySelected'}
                htmlAttributes={{}}
              >
                <label>Canada</label>
              </RadioButton>
            </RadioContainer>
          </HalfRadioContainer>
          <AddressGroup
            value={formData.ownerAddress}
            onChange={(address) => { setFormData({ ownerAddress: address }) }}
            suggestionEndpoint={MDMS_URL + '/api/v1/smarty/suggestions'}
            showComplaints={false}
            country={formData.ownerCountrySelected}
          />
        </>
      }
      <NextButton
        data-track="form-advance"
        data-track-form-name="Warranty Transfer"
        data-track-form-step="step 3 - method of contact"
        onClick={verifyAddress} disabled={!validated}
      >
        Next
      </NextButton>
      <AddressVerificationModal />
    </StepWrapper>
  )
};

const mapDispatchToProps = dispatch => (
  {
    decrementStep: () => dispatch(decrementStep()),
    setFormData: (hash) => dispatch(setFormData(hash)),
    verifyAddress: () => dispatch(verifyAddress()),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Step3);

